import { map } from 'lodash';
import { v4 as uuid } from 'uuid';
import { toUUID } from '../../util/transform';
import type { ITicketConveyancingLoan } from './TicketConveyancingLoan.interface';
import TicketConveyancingLoanDetails from './TicketConveyancingLoanDetails';
import TicketLoanSecuritySplit from './TicketLoanSecuritySplit';
import TicketLoanFee from './TicketLoanFee';

export default class TicketConveyancingLoan implements ITicketConveyancingLoan {
  id: string;
  dealConveyancingSecuritySplit: Array<TicketLoanSecuritySplit>;
  details: TicketConveyancingLoanDetails;
  fees: Array<TicketLoanFee>;

  static build = (data: ITicketConveyancingLoan) => new TicketConveyancingLoan(data);
  static blank = () => new TicketConveyancingLoan({ id: uuid() });

  /**
   * Constructor
   * @param {ITicketConveyancingLoan} data
   */
  constructor(data?: ITicketConveyancingLoan) {
    this.id = toUUID(data?.id) || uuid();
    this.dealConveyancingSecuritySplit = map(
      data?.dealConveyancingSecuritySplit,
      (obj) => new TicketLoanSecuritySplit(obj)
    );
    this.details = new TicketConveyancingLoanDetails(data?.details);
    this.fees = map(data?.fees, (obj) => new TicketLoanFee(obj));
  }
}
